module.exports = __webpack_public_path__ + "static/img/kb-card.9274b15.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/kb-card.jpg
// module id = tfFf
// module chunks = 0